import React from 'react'
import PropTypes from 'prop-types';

const I18n = ({message, params}) => <span>{i18n.get(message, params)}</span>;

I18n.propTypes = {
  message: PropTypes.string
};

I18n.message = (...args) => i18n.get.apply(this, args);

export default I18n;



// WEBPACK FOOTER //
// ./src/js/Component/I18n.jsx